import "@/styles/hugeicons.css";

import * as _ from "lodash-es";
import { createApp, h } from "vue";
import { createVfm } from "vue-final-modal";

import setupVue from "@/vue-setup";

import App from "./App.vue";
import { router } from "./routes/router";

// Patch addEventListener to make wheel events passive by default
// This fixes the browser warning about non-passive wheel event listeners
// Must be applied before Vue initializes to catch all event listeners
if (typeof window !== "undefined" && typeof EventTarget !== "undefined") {
  const originalAddEventListener = EventTarget.prototype.addEventListener;
  EventTarget.prototype.addEventListener = function (
    type: string,
    listener: EventListenerOrEventListenerObject | null,
    options?: boolean | AddEventListenerOptions
  ) {
    // For wheel events, ensure passive is true unless explicitly set to false
    if (type === "wheel" || type === "mousewheel") {
      if (typeof options === "boolean") {
        // If options is a boolean (useCapture), convert to object with passive: true
        options = { capture: options, passive: true };
      } else if (typeof options === "object" && options !== null) {
        // If options is an object, set passive to true unless explicitly false
        if (options.passive === undefined) {
          options = { ...options, passive: true };
        }
      } else {
        // If no options provided, default to passive: true
        options = { passive: true };
      }
    }
    return originalAddEventListener.call(this, type, listener, options);
  };
}

async function main() {
  globalThis.router = router;

  const vue = createApp({
    setup() {
      return () => h(App);
    },
  });
  globalThis.vue = vue;

  // Plugins, directives...
  setupVue(vue);
  vue.use(router);

  const vfm = createVfm();
  vue.use(vfm).mount("#app");
}

main();
